import React from 'react';
import { NavLink } from 'react-router-dom';

import classes from './NavigationButtonItem.css';

const navigationbuttonitem = ( props ) => (
        <NavLink 
            className={classes.NavigationButtonItem}
            to={props.link}
            exact
            activeClassName={classes.active}>
            {props.children}
        </NavLink>
);

export default navigationbuttonitem;